export const MATERNITY_ULTRA_KEY = 'appointment.reservation.maternityultra';
